import React, { useEffect } from 'react';
import Container from '../components/Container';
import courseImg from "../images/course7.jpg";
import "../styles/courses.css";
import { BiHomeAlt2 } from "react-icons/bi";
   import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
 
const CoursesLoader = () => {
   

  return (
    
    
   <>
  
         
                 {[...Array(10)].map((_, index) => (
                  <tr >
                    <td>
                         <Skeleton width="100%" height="15px" />
                    </td>
                    <td>
                         <Skeleton width="100%" height="15px" />
                    </td>
                    <td> 
                         <Skeleton width="100%" height="15px" />
                    </td>
                    <td>
                         <Skeleton width="100%" height="15px" />
                    </td>
                    <td>
                         <Skeleton width="100%" height="15px" />
                    </td>
                    <td>
                      
                        <Skeleton width="100%" height="15px" />
                       
                    </td>
                  </tr>
                
                ))}
           
     </>
    
  );
};

export default CoursesLoader;
